module.exports = __webpack_public_path__ + "img/Slide5.d0f87330.png";